import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import styled, { css } from 'styled-components';
import { useState, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useDebouncedCallback } from 'use-debounce';
import Image from 'next/legacy/image';
import { Text } from '@yoweb/ui/components/typography';
import InputUI from '@yoweb/ui/components/form/Input/InputUI';
import { ButtonIcon } from '@yoweb/ui/components/buttons/ButtonIcon';
import { Box } from '@yoweb/ui/components/Box';
import { LineClamp } from '@yoweb/ui/components/LineClamp';
import { CustomTodoBanner } from './TodoCard';
import Spinner from '@yoweb/ui/components/Spinner';
import { useTranslation } from '@yoweb/next-i18next';
import { API_TASK_TEMPLATE_SEARCH_DISCOVERY } from '@poplar/constants/routes';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { CloseIconSmall, NoMediaIcon } from '@yoweb/ui/components/Icon';
import useClickOutside from '@yoweb/ui/hooks/useClickOutside';
import { getColor, getSpace } from '@yoweb/ui/styles/utils/theme';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { NO_CTA_ID } from '@yoweb/utils/constants/analyticEvents';
import { TodoEntryPoint, TodoType, Action } from '@yoweb/types/external-events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Search = function Search(_ref) {
  var _searchResults$search;

  var isSearchActiveRef = _ref.isSearchActiveRef,
      onTemplateClicked = _ref.onTemplateClicked,
      onCreateCustomClicked = _ref.onCreateCustomClicked;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(''),
      searchTerm = _useState[0],
      setSearchTerm = _useState[1];

  var _useState2 = useState(),
      searchResults = _useState2[0],
      setSearchResults = _useState2[1];

  var _useState3 = useState(false),
      showSearchResults = _useState3[0],
      setShowSearchResults = _useState3[1];

  var _useState4 = useState(false),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useToast = useToast(),
      showToastError = _useToast.showToastError;

  var fetchSearchResults = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var searchResultsRes;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              trackEvent({
                cta: {
                  action: Action.ACTION_TODO_DISCOVERY_SEARCH_TRIGGERED,
                  id: NO_CTA_ID
                }
              });
              _context.prev = 2;

              if (!searchTerm) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return fetchJson(API_TASK_TEMPLATE_SEARCH_DISCOVERY(searchTerm));

            case 6:
              _context.t0 = _context.sent;
              _context.next = 10;
              break;

            case 9:
              _context.t0 = undefined;

            case 10:
              searchResultsRes = _context.t0;
              setSearchResults(searchResultsRes);
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t1 = _context["catch"](2);
              showToastError();
              throw _context.t1;

            case 18:
              _context.prev = 18;
              setIsLoading(false);
              return _context.finish(18);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 14, 18, 21]]);
    }));

    return function fetchSearchResults() {
      return _ref2.apply(this, arguments);
    };
  }();

  var debouncedFetchSearchResults = useDebouncedCallback(fetchSearchResults, 1000);

  var selectTemplate = function selectTemplate(templateId, skipPdp) {
    onTemplateClicked(templateId, skipPdp);
    setSearchTerm('');
    setSearchResults(undefined);
    isSearchActiveRef.current = false;
  };

  return /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(InputUI, {
      id: "template-search",
      name: "template-search",
      "data-testid": "template-search",
      label: searchTerm ? '' : t('todo-discovery.search-label'),
      onChange: function onChange(e) {
        if (e.target.value === '') {
          isSearchActiveRef.current = false;
        }

        setSearchTerm(e.target.value);
        void debouncedFetchSearchResults();
      },
      onClick: function onClick() {
        setShowSearchResults(true);
        isSearchActiveRef.current = true;
        trackEvent({
          cta: {
            action: Action.ACTION_TODO_DISCOVERY_SEARCH_ENTERED,
            id: NO_CTA_ID
          }
        });
      },
      autoComplete: "off",
      value: searchTerm,
      icon: searchTerm ? /*#__PURE__*/_jsx(ButtonIcon, {
        size: "sm",
        mode: "dark",
        variant: "primary",
        type: "button",
        isFloating: false,
        icon: /*#__PURE__*/_jsx(CloseIconSmall, {
          size: 24
        }),
        bgColor: "inherit",
        onClick: function onClick() {
          trackEvent({
            cta: {
              action: Action.ACTION_TODO_DISCOVERY_SEARCH_CANCEL,
              id: NO_CTA_ID
            }
          });
          setSearchTerm('');
          setSearchResults(undefined);
          isSearchActiveRef.current = false;
        }
      }) : undefined,
      children: /*#__PURE__*/_jsx(AnimatePresence, {
        initial: false,
        children: (searchResults || isLoading) && showSearchResults && /*#__PURE__*/_jsx(SearchResultContainer, {
          onClose: function onClose() {
            return setShowSearchResults(false);
          },
          numberOfSearchResults: searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchDiscoveryResultsList.length,
          children: /*#__PURE__*/_jsx(Box, {
            p: "small3",
            display: "flex",
            flexDirection: "column",
            children: isLoading ? /*#__PURE__*/_jsxs(Box, {
              display: "flex",
              flexDirection: "column",
              gap: "normal1",
              py: "medium1",
              px: "normal1",
              children: [/*#__PURE__*/_jsx(Box, {
                display: "flex",
                justifyContent: "center",
                children: /*#__PURE__*/_jsx(Spinner, {})
              }), /*#__PURE__*/_jsx(Text, {
                textAlign: "center",
                weight: "semibold",
                children: t('todo-discovery.search-placeholder')
              })]
            }) : /*#__PURE__*/_jsxs(_Fragment, {
              children: [searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$search = searchResults.searchDiscoveryResultsList) === null || _searchResults$search === void 0 ? void 0 : _searchResults$search.map(function (_ref3, i) {
                var templateId = _ref3.templateId,
                    skipPdp = _ref3.skipPdp,
                    sampleTodoTitle = _ref3.sampleTodoTitle,
                    iconImageUrl = _ref3.iconImageUrl;
                return /*#__PURE__*/_jsxs(SearchResult // eslint-disable-next-line react/no-array-index-key
                , {
                  display: "flex",
                  alignItems: "center",
                  gap: "normal1",
                  tabIndex: 0,
                  radii: "small",
                  p: "small3",
                  onClick: function onClick() {
                    selectTemplate(templateId, skipPdp);
                    trackEvent({
                      todoStart: {
                        title: sampleTodoTitle,
                        entryPoint: TodoEntryPoint.TODO_ENTRY_POINT_TODO_DISCOVERY,
                        type: skipPdp ? TodoType.TODO_TYPE_B : TodoType.TODO_TYPE_A
                      }
                    });
                  },
                  "data-testid": "search-result",
                  children: [/*#__PURE__*/_jsx(Box, {
                    backgroundColor: "sand",
                    p: "small3",
                    radii: "small",
                    height: 40,
                    width: 40,
                    children: iconImageUrl ? /*#__PURE__*/_jsx(Image, {
                      src: iconImageUrl,
                      width: "24",
                      height: "24"
                    }) : /*#__PURE__*/_jsx(NoMediaIcon, {
                      height: 24,
                      width: 24
                    })
                  }), /*#__PURE__*/_jsx(LineClamp, {
                    lines: 2,
                    children: sampleTodoTitle
                  })]
                }, "search-result-".concat(i));
              }), searchResults !== null && searchResults !== void 0 && searchResults.searchDiscoveryResultsList.length ? /*#__PURE__*/_jsx(CustomTodoBanner, {
                title: t('todo-discovery.something-else'),
                ctaText: t('todo-intake.create-type-c'),
                onClick: onCreateCustomClicked
              }) : undefined, (searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchDiscoveryResultsList.length) === 0 && /*#__PURE__*/_jsx(Box, {
                my: "normal3",
                children: /*#__PURE__*/_jsx(CustomTodoBanner, {
                  title: t('todo-discovery.not-in-list'),
                  ctaText: t('todo-intake.create-type-c'),
                  onClick: onCreateCustomClicked
                })
              })]
            })
          })
        })
      })
    })
  });
};

var SearchResultContainer = function SearchResultContainer(_ref4) {
  var onClose = _ref4.onClose,
      _ref4$numberOfSearchR = _ref4.numberOfSearchResults,
      numberOfSearchResults = _ref4$numberOfSearchR === void 0 ? 0 : _ref4$numberOfSearchR,
      children = _ref4.children;
  var ref = useRef(null);
  useClickOutside(ref, onClose);
  return /*#__PURE__*/_jsx(motion.div, {
    animate: "animate",
    initial: "initial",
    exit: "exit",
    variants: {
      initial: {
        opacity: 0,
        y: -5
      },
      animate: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
          type: 'spring'
        }
      },
      exit: {
        opacity: 0,
        y: -5,
        transition: {
          duration: 0.2
        }
      }
    },
    children: /*#__PURE__*/_jsx(SearchResultWrapper, {
      position: "absolute",
      maxHeight: 295,
      backgroundColor: "base000",
      radii: "small",
      mt: "small4",
      left: -16,
      right: -16,
      ref: ref,
      showScrollOnHover: numberOfSearchResults > 5,
      "data-testid": "search-container",
      children: children
    })
  });
};

var SearchResult = styled(Box).withConfig({
  componentId: "sc-1chhsm7-0"
})(["&&{cursor:pointer;&:hover{background-color:", ";}}"], getColor('sand'));
var SearchResultWrapper = styled(Box).withConfig({
  componentId: "sc-1chhsm7-1"
})(["&&{border:1px solid ", ";box-shadow:1px 6px 20px 0 rgba(0 0 0 / 30%);overflow-y:auto;@media (hover:hover){", "}}"], getColor('sand'), function (_ref5) {
  var showScrollOnHover = _ref5.showScrollOnHover;
  return showScrollOnHover && css(["&::-webkit-scrollbar{background-color:transparent;width:", ";}&:hover{&::-webkit-scrollbar-thumb{background-color:", ";border-radius:", ";}}"], getSpace('small3'), getColor('base400'), getSpace('small3'));
});
export default Search;